export default "__VITE_ASSET__iFge1byW__"